import React from 'react'

export const ToolsStyles: { [key: string]: React.CSSProperties } = {
    container: {
        width: '100%',
        position: 'relative',
    },
    content: {
        width: '100%',
        paddingTop: 10,
        display: 'flex',
        overflow: 'auto',
        paddingBottom: 10,
        flexWrap: 'nowrap',
    },
    btnContent: {
        width: 220,
        minWidth: 220,
        maxWidth: 220,
        height: 181,
        minHeight: 160,
        maxHeight: 160,
        marginLeft: 5,
        marginRight: 10,
        display: 'flex',
        borderRadius: 10,
        cursor: 'pointer',
        position: 'relative',
        flexDirection: 'column',
        backgroundColor: '#fff',
        boxShadow: '0px 1px 3px 0px #0000001A',
    },
    icon: {
        height: '100%',
        paddingTop: 30,
        paddingLeft: 20,
        display: 'flex',
        paddingRight: 5,
        flexDirection: 'row',
        boxSizing: 'border-box',
        alignItems: 'flex-start',
        justifyContent: 'flex-end',
    },
    btnBody: {
        flex: 1,
        height: '100%',
        paddingTop: 25,
        paddingLeft: 10,
        display: 'flex',
        paddingRight: 10,
        textAlign: 'start',
        boxSizing: 'border-box',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
    },
}
